import { Patient } from '@common/models/patients/types';

const getObfuscatedPatientName = (patient: Patient): string => {
  return `${patient.firstName.slice(0, 1)}. ${patient.lastName.slice(0)}`;
};

export default getObfuscatedPatientName;
